import { Switch } from "antd";
import styled from "styled-components";

export const FloatingSwitch = styled(Switch)`
    float: left;
    margin: 5px 20px 0 0;
`;
